import { CycleUtils } from '@wix/package-picker-shared';
import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
export const PackagePickerStoreExtension = ModuleExtensions.storeExtension({
  selectedProductId: null,
  selectedCycleId: null
}, 'PackagePickerStore', {
  useSelectedProductId: state => {
    return state.selectedProductId;
  },
  useSelectedCycleId: state => {
    return state.selectedCycleId;
  },
  useSelectedCycle: state => {
    return CycleUtils.convertCycleIdToCycle(state.selectedCycleId);
  }
}, {
  setSelectedProductId: (_ref, newSelectedProductId) => {
    let {
      draft
    } = _ref;
    draft.selectedProductId = newSelectedProductId;
    const url = new URL(window.location.href);
    if (!newSelectedProductId) {
      url.searchParams.delete('productId');
    } else {
      url.searchParams.set('productId', newSelectedProductId);
    }
    window.history.replaceState({}, '', url.toString());
  },
  setSelectedCycleId: (_ref2, newSelectedCycleId) => {
    let {
      draft
    } = _ref2;
    draft.selectedCycleId = newSelectedCycleId;
    const url = new URL(window.location.href);
    if (!newSelectedCycleId) {
      url.searchParams.delete('cycleId');
    } else {
      url.searchParams.set('cycleId', newSelectedCycleId);
    }
    window.history.replaceState({}, '', url.toString());
  }
});
//# sourceMappingURL=packagePickerStore.extension.js.map